import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity, JoinColumn, ManyToOne, BeforeInsert, BeforeUpdate } from 'typeorm';
import { booleanTransformer, GenPartial, momentTransformer } from 'typeormgen';
import MoneyTrackingGroup from '../money-tracking-groups/money-tracking-group.entity';
import ProdBase from '../prod-base.entity';

@Entity('budget_characters')
export default class BudgetCharacter extends ProdBase {
	static tableName = 'budget_characters';

	@Column('int')
	episodic_character_id: number;

	@Column('int')
	money_tracking_group_id: number;

	@Column('varchar')
	name: string;

	@Column('varchar')
	char_num: string;

	@BeforeInsert()
	@BeforeUpdate()
	trimCharNum() {
		if (this.char_num){
			this.char_num = this.char_num.trim();
		}
	}

	@Column({ type: 'int', transformer: booleanTransformer })
	is_primary: boolean;

	@Column('int')
	is_summed: number;

	@Column('decimal')
	total: string;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@ManyToOne(
		type => MoneyTrackingGroup,
		moneyTrackingGroup => moneyTrackingGroup.budgetCharacters
	)
	@JoinColumn({
		name: 'money_tracking_group_id',
	})
	moneyTrackingGroup: MoneyTrackingGroup;

	static rules() {
		return {
			...super.rules(),
			char_num: Joi
				.string()
				.max(100)
				.allow(null),
			created_by: Joi
				.number()
				.integer()
				.allow(null),
			date_created: Joi.date().allow(null),
			episodic_character_id: Joi
				.number()
				.integer()
				.allow(null),
			is_primary: Joi.boolean(),
			is_summed: Joi.number().integer(),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi
				.number()
				.integer()
				.allow(null),
			money_tracking_group_id: Joi
				.number()
				.integer()
				.allow(null),
			name: Joi.string().max(255),
			total: Joi
				.string()
				.max(21)
				.allow(null),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			char_num: this.char_num,
			created_by: this.created_by,
			date_created: this.date_created,
			episodic_character_id: this.episodic_character_id,
			is_primary: this.is_primary,
			is_summed: this.is_summed,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			money_tracking_group_id: this.money_tracking_group_id,
			name: this.name,
			total: this.total,
		};
	}

	assign(props?: GenPartial<BudgetCharacter>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
			if (typeof props.is_primary !== 'undefined') {
				this.is_primary = booleanTransformer.from(props.is_primary);
			}
		}
	}

	constructor(props?: GenPartial<BudgetCharacter>) {
		super(props);
	}
}
